import { useDispatch, useSelector } from 'react-redux'
import { motion, AnimatePresence } from 'framer-motion'

import { XMarkIcon } from '@heroicons/react/24/solid'
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline'
import { selectIsOpened, toggleWidget } from 'store/widget'
import { useMemo } from 'react'
import ObjectID from 'bson-objectid'
import { useConfigureChat } from 'components/WidgetLayout'
import { store } from 'store/index'
import { useGetSetting } from 'api/settings'

export const WidgetLauncher = () => {
  const { setting } = useGetSetting()
  const widgetId = useMemo(() => String(ObjectID()), [])
  const dispatch = useDispatch()
  const isOpened = useSelector(selectIsOpened)
  const initializeChat = useConfigureChat()

  return (
    <motion.div
      key={widgetId}
      animate={{
        scale: [0, 1.1, 1],
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}
      className={`tw-fixed tw-right-5 tw-bottom-2 tw-mr-2 tw-inline-flex tw-cursor-default tw-items-center tw-rounded-full tw-p-2 tw-text-center tw-text-sm tw-font-medium tw-text-white tw-xs:right-0`}
      style={{ backgroundColor: setting?.primaryColor, color: 'white' }}
      onClick={(e) => {
        e.preventDefault()
        dispatch(toggleWidget())

        setTimeout(() => {
          const newIsOpened = store.getState().widgetState.isOpened
          if (newIsOpened) {
            initializeChat().catch(console.error)
          }
        }, 10)
      }}
    >
      <AnimatePresence key={'animated-presence-1'}>
        {isOpened ? (
          <motion.div
            key={'animated-presence-2'}
            animate={{
              rotate: [0, 90],
            }}
          >
            <XMarkIcon className="tw-h-12 tw-w-12" />
          </motion.div>
        ) : (
          <motion.div key={'animated-presence-2'} animate={{ opacity: 1 }}>
            <ChatBubbleOvalLeftEllipsisIcon className="tw-h-12 tw-w-12" />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}
